export const CaseButton = {
  // 在线做题
  ONLINE: 0,
  // 分析报告
  MUTATION_ANALYSIS: 1,
  // 创建报告
  CREATE_REPORT: 2,
  // 我的报告
  MY_REPORT: 3,
  // 考试入口
  EXAM_ENTRANCE: 4,
  // 密钥
  SECRET: 5,
  // 缺陷评分
  BUG_MARK: 6,
  // 上传文件
  UPLOAD_FILE: 7,
  // 人工评分
  MANUAL_SCORE: 8,
  // 众包测试
  CROWD_TEST: 9,
  // 众审
  CROWD_CHECK: 10,
  // 在主站通过路由跳转做题，不需要跳转至webIDE
  TOCODE: 11,
  // web应用和移动应用验收
  INSPECT: 14,
  // 慕码题
  ONLINE_JUDGE: 12,
};
